import React, { Component } from 'react';

class ProgrammeEvents extends Component {
    render() {
        const rows = this.props.events.map((event, i) => (
            <div key={i} className="programmeEvent">
                <h5>{event.header}</h5>
                <p>{event.detail}</p>
            </div>
        ));

        return (
            <div>
                {rows}
            </div>
        );
    }
}

export default ProgrammeEvents;


// WEBPACK FOOTER //
// ./src/components/programmeEvents.jsx